const YoutubeIcon = ({ color }: { color?: string }) => (
  <svg
    width="36"
    height="25"
    viewBox="0 0 36 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.2218 5.24975C35.2218 5.24975 34.884 2.86473 33.8435 1.81748C32.526 0.439169 31.0531 0.432412 30.3774 0.351335C25.5398 -1.93303e-07 18.2766 0 18.2766 0H18.2631C18.2631 0 10.9999 -1.93303e-07 6.16233 0.351335C5.48669 0.432412 4.01379 0.439169 2.69628 1.81748C1.65579 2.86473 1.32472 5.24975 1.32472 5.24975C1.32472 5.24975 0.973389 8.05368 0.973389 10.8508V13.4723C0.973389 16.2695 1.31797 19.0734 1.31797 19.0734C1.31797 19.0734 1.65579 21.4585 2.68952 22.5057C4.00703 23.884 5.73668 23.8367 6.50691 23.9854C9.27705 24.2489 18.2699 24.3299 18.2699 24.3299C18.2699 24.3299 25.5398 24.3164 30.3774 23.9719C31.0531 23.8908 32.526 23.884 33.8435 22.5057C34.884 21.4585 35.2218 19.0734 35.2218 19.0734C35.2218 19.0734 35.5664 16.2763 35.5664 13.4723V10.8508C35.5664 8.05368 35.2218 5.24975 35.2218 5.24975ZM14.6957 16.6546V6.93211L24.0399 11.8103L14.6957 16.6546Z"
      fill={color || "white"}
    />
  </svg>
);

export default YoutubeIcon;
